import React, {useState} from "react";

import Alerter from "../../../../../Components/Common/Alerter";
import ContactModal from "../../../../../Components/Common/ContactModal";
import Spinner from "../../../../../Components/Common/Spinner";
import {addItem} from "../../../../../../services/cartApi";
import {getCartSnapshot, setCart as setCartState} from "../../../../../../services/cartState";
import {trackAddToCart} from "../../../../../../services/cartAnalytics";
import {show as showCartPopup, showOrderLimit as showOrderLimitPopup} from "../../../../../../services/cartPopup";
import {useReplaceCartConfirmation} from "../../../../../../services/cartConfirmations.react";

const parseGaData = (raw) => {
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

const findRowPrice = (buttonEl) => {
    if (!buttonEl) return undefined;
    const row = buttonEl.closest('tr');
    return row?.querySelector('span[data-price]')?.getAttribute('data-price') ?? undefined;
};

const TableTdOrder = ({login, lang, gaData, cart, productKey, partno, isSpecial, urlIconCar, item, contactDetails, loadingPriceList, priceValue}) => {
    const [count, setCount] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [requestSent, setRequestSent] = useState(false);
    const [adding, setAdding] = useState(false);
    const [replaceCartConfirmation, requestReplaceCartConfirmation] = useReplaceCartConfirmation();

    const handleLoginClick = (e) => {
        e.preventDefault();
        const loginPopup = document.querySelector('.login-popup');
        if (loginPopup) {
            loginPopup.classList.add('init', 'is-active');
        }
        document.body.classList.add('is-locked');
    };

    const handleModalToggle = () => {
        setShowModal(!showModal);
    };

    const handleAddToCart = async (e) => {
        e.preventDefault();
        if (adding || count < 1) return;

        const snapshot = getCartSnapshot();
        const {confirmed, cleanCart} = await requestReplaceCartConfirmation(snapshot);
        if (!confirmed) return;

        const price = findRowPrice(e.currentTarget);
        setAdding(true);
        try {
            const res = await addItem({
                productId: productKey,
                unit: item?.unit_code,
                count,
                special: isSpecial,
                cleanCart,
            });
            if (res.error) {
                showOrderLimitPopup();
                return;
            }
            setCartState({
                total: res.total,
                count: res.count,
                hasQuotation: Boolean(res.hasQuotation),
            });
            showCartPopup({
                partNumber: partno ?? productKey,
                price,
                count: res.count,
            });
            const gaObj = parseGaData(gaData);
            if (gaObj) trackAddToCart(gaObj, count);
            setCount(1);
        } finally {
            setAdding(false);
        }
    };

    if (loadingPriceList && !priceValue) {
        return <Spinner/>;
    }

    if (login === true) {
        return (
            <button
                onClick={handleLoginClick}
                className="btn btn-secondary btn--small login-popup-trigger p-1">
                {lang?.order_button}
            </button>
        );
    }

    if (cart === true) {
        return (
            <>
                <div className="d-flex justify-content-center update_amount">
                    <div className="input-group w-auto mr-1">
                        <input
                            type="number"
                            className="text-center form-control-small"
                            style={{width: '50px'}}
                            onChange={(e) => setCount(Math.max(1, Number(e.target.value) || 1))}
                            value={count}
                            min="1"
                            disabled={adding}
                        />
                    </div>
                    <button
                        type="button"
                        onClick={handleAddToCart}
                        disabled={adding}
                        className="d-flex btn btn-secondary btn--small"
                    >
                        <IconCar url={urlIconCar}/>
                        {isSpecial === false ?? (
                            <h6 style={{lineHeight: '28px'}}>
                                {lang?.shoppingcart}
                            </h6>
                        )}
                        {adding && (
                            <span className="py-0 px-1">
                                <i className="fa fa-spinner fa-spin mx-1"/>
                            </span>
                        )}
                    </button>
                </div>
                {replaceCartConfirmation}
            </>
        );
    }

    return (
        <>
            <button className="btn btn-secondary btn--small py-0 px-1" onClick={handleModalToggle}>
                {requestSent && <i className="fa fa-check"></i>}
                Contact
            </button>
            {showModal && (
                <Alerter onCancel={handleModalToggle}>
                    {(onCancel) => (
                        <ContactModal
                            contactDetails={contactDetails}
                            onSend={() => {
                                setRequestSent(true);
                                handleModalToggle();
                            }}
                            onCancel={onCancel}
                            data={{
                                partno: partno,
                                productKey: productKey,
                                product_title: item.product_title ?? '',
                                product_type_title: item.product_type_title ?? '',
                                product_group_title: item.product_group_title ?? '',
                                product_detail_title: item.product_detail_title ?? '',
                            }}
                        />
                    )}
                </Alerter>
            )}
        </>
    );
};

const IconCar = ({url}) => {
    return <img src={url} alt={'car'} className="mr-1"/>;
};

export default TableTdOrder;
